<template>
    <AppLayout v-bind="customerSharedData.getAppLayoutProps(pageMeta)">
        <div class="mt-4 space-y-8">
            <div
                v-for="meetingData in localMeetingsData"
                :key="meetingData.meeting.id.value"
            >
                <CustomerMeetingCard
                    :meetingData="meetingData"
                    :attendanceData="
                        meetingData.getSingleExistingAttendanceData()
                    "
                    :reservationData="
                        meetingData.getSingleExistingReservationData()
                    "
                />
            </div>
        </div>

        <div>
            <Pagination
                as="a"
                :searchResults="paginatedMeetingsData"
                :url="
                    urlFactory.makeCompanyCustomerMeetingsUrl(
                        localCompany.id.value,
                    )
                "
            />
        </div>
    </AppLayout>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import AppLayout from '@/Shared/Layout/Customer/Topbar/AppLayout.vue'
    import CustomerMeetingCard from '@/Customer/Meeting/Component/CustomerMeetingCard.vue'
    import Pagination from '@/Shared/Component/Pagination.vue'
    import {
        type PageMeta,
        type PaginatedResultsType,
    } from '@/Shared/AutoGenerated/Main'
    import CustomerSharedData from '@/Shared/Entity/CustomerSharedData'
    import MeetingData from '@/App/Booking/Meeting/Entity/MeetingData'
    import Company from '@/App/Company/Entity/Company'

    interface IndexMeetingsProps {
        pageMeta: PageMeta
        customerSharedDataData: any
        paginatedMeetingsData: PaginatedResultsType
        companyData: any
    }

    const props = defineProps<IndexMeetingsProps>()
    const customerSharedData = CustomerSharedData.hydrate(
        props.customerSharedDataData,
    )
    const customerId = customerSharedData.getAuthCustomer().id
    const localMeetingsData = MeetingData.hydrateMultiple(
        props.paginatedMeetingsData.records,
    )
    const localCompany = Company.hydrateSingle(props.companyData)
    const urlFactory = new UrlFactory()
</script>
